import { Injectable } from '@angular/core';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { BehaviorSubject, Observable, of, throwError, catchError, concatMap, finalize, tap } from 'rxjs';

interface ErrorStatus {
  errors?: string[];
  message?: string;
  status?: string;
}
@Injectable({
  providedIn: 'root',
})
export class LoadingPageService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();

  private _error = new BehaviorSubject<ErrorStatus>(undefined);
  public readonly error$ = this._error.asObservable();

  constructor(private notificationService: NotificationsService) {}
  showLoadingUntilCompleted<T>(observable$: Observable<T>) {
    return of(null).pipe(
      tap(() => {
        this.loading();
      }),
      concatMap(() => observable$),

      catchError((error: ErrorStatus) => {
        console.error(error);

        this.setErrors(error);

        this.loaded();
        this.notificationService.error(
          'Error ',
          'Une erreur est survenue lors de la sauvegarde',
          {
            timeOut: 5000,
          },
        );
        return throwError(error);
      }),
      tap(() => {
        this.setErrors(undefined);
      }),

      finalize(() => {
        this.loaded();
      }),
    );
  }
  loading() {
    this._loading.next(true);
  }

  loaded() {
    this._loading.next(false);
  }
  setErrors(error: ErrorStatus) {
    this._error.next(error);
  }
  getErrors() {
    return this._error.value;
  }
}
